import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { GetCompletionEventsResponseDto } from '@tempo-io/fim3-dto';
import type { AxiosInstance } from 'axios';
import { completionEventsQueryKeys } from '../../../lib/query-keys/completionEvents';

export const useCompletionEventsApi = (httpClient: AxiosInstance) => {
  const baseUrl = `/completion-events`;
  const queryClient = useQueryClient();

  const useGetOpenEvents = () =>
    useQuery({
      queryKey: completionEventsQueryKeys.list(),
      queryFn: async (): Promise<GetCompletionEventsResponseDto> => {
        const { data } = await httpClient.get(baseUrl);
        return data;
      },
    });

  const useDismissEvent = () =>
    useMutation({
      mutationFn: async (id: number) => {
        await httpClient.post(`${baseUrl}/${id}/dismiss`);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: completionEventsQueryKeys.list() });
      },
    });

  const useMarkAsViewed = () =>
    useMutation({
      mutationFn: async (id: number) => {
        await httpClient.post(`${baseUrl}/${id}/view`);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: completionEventsQueryKeys.list() });
      },
    });

  return { useGetOpenEvents, useDismissEvent, useMarkAsViewed };
};
